import React, {useEffect, useState} from 'react';
import {Col, Modal, notification, Row, Spin, Button} from "antd";
import '../modals.css';
import {approveOrderService} from "../../../services/approve-order.service";
import {fileHelper} from "../../../helpers/file.helper";
import i18n from "i18next";

export default function ModalShowContractFiles({isShow, setIsShow, id}) {

  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  useEffect(() => {
    setLoading(true);
    if (id && isShow) {
      approveOrderService
        .getContractsListOnUpload(id)
        .then(resp => {
          setInfo(resp);
          setLoading(false);
        })
        .catch(errMsg => notification.error(
          {
            message: i18n.t('components.notification.titles.getContractsListOnUpload2'),
            description: errMsg
          }));
    }
  }, [id, isShow]);

  const handleDownloadDoc = fileUrl => {
    window.open(fileUrl);
  };

  const handleDownloadDocsArchive = (id) => {
    approveOrderService.getDownloadContractOrderFiles(id)
      .then(resp => {
        fileHelper.downloadFileBase64(resp, 'contracts.zip')
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.getLegalEntityDocsArchive'),
          description: err
        });
      });
  };

  const renderButtonsDownload = info => {
    let buttons = [];

    Object.keys(info).forEach(key  => {
      const value = info[key];
      const hasUploadedFile = !!value.uploadedFile;
      const hasBlankFile = !!value.blankFile;
     
      if (!hasUploadedFile && !hasBlankFile) return;

      // Если есть только blankFile - показываем только его
      if (hasBlankFile && !hasUploadedFile) {
        buttons.push(
            <Button
                key={`blank-${key}`}
                style={{marginLeft: "0px", width: "100%"}}
                onClick={() => handleDownloadDoc(value.blankFile)}
                size="small"
                className="small-button typical-btn-blue"
            >
              {i18n.t('main.buttons.downloadOriginal')} "{value.alias}"
            </Button>
        );
        return;
      }

      // Если есть оба файла - показываем оба
      if (hasUploadedFile && hasBlankFile) {
        buttons.push(
            <React.Fragment key={`both-${key}`}>
              <Button
                  style={{marginLeft: "0px", width: "100%"}}
                  onClick={() => handleDownloadDoc(value.uploadedFile)}
                  size="small"
                  className="small-button typical-btn-green"
              >
                {i18n.t('main.buttons.download')} "{value.alias}"
              </Button>
              <Button
                  style={{marginLeft: "0px", width: "100%"}}
                  onClick={() => handleDownloadDoc(value.blankFile)}
                  size="small"
                  className="small-button typical-btn-blue"
              >
                {i18n.t('main.buttons.downloadOriginal')} "{value.alias}"
              </Button>
            </React.Fragment>
        );
        return;
      }

      // Если есть только uploadedFile - показываем только его
      if (hasUploadedFile && !hasBlankFile) {
        buttons.push(
            <Button
                key={`uploaded-${key}`}
                style={{marginLeft: "0px", width: "100%"}}
                onClick={() => handleDownloadDoc(value.uploadedFile)}
                size="small"
                className="small-button typical-btn-green"
            >
              {i18n.t('main.buttons.download')} "{value.alias}"
            </Button>
        );
      }
    });

    return (
      <>
        {buttons}
      </>
    );
  };

  let buttons = renderButtonsDownload(info);

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('modals.modalShowContractFiles.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={<Row>
        <Col offset={8} span={8}>
          <Button
            htmlType="button"
            key="submitPrev"
            onClick={() => handleDownloadDocsArchive(id)}
            type="primary"
            size="large"
            style={{width: '100%'}}
          >
            {i18n.t('modals.modalShowContractFiles.buttons.download')}
          </Button>
        </Col>
      </Row>}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row type="flex" justify="center">
          <Col lg={8} md={24} sm={24} xs={24}>
            {buttons}
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}
